import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Users'

export const UsersEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller) 
        .setActionName("PrepareDoLoginAsUser"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller) 
        .setActionName("DoLoginAdminOrTrainer"),
    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)        
        .setActionName("DoLogout"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)        
        .setActionName("RegisterTrainer"),
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)        
        .setActionName("ChangeMyPasswordStep1"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("ChangeMyPasswordStep2")
        .setPattern("{hash}"),    
    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)        
        .setActionName("ResendValidateAccountEmail"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("ValidateAccount")
        .setPattern("{hash}"),
    new EndPointConfig()
        .setMethod('PUT')
        .setController(controller)        
        .setActionName("UpdateUserProfile"),
    new EndPointConfig()
        .setMethod('PUT')
        .setController(controller)        
        .setActionName("UpdateCustomerProfile"),
    new EndPointConfig()
        .setMethod('PUT')
        .setController(controller)        
        .setActionName("ChangeCustomerUserName"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('GetUsers')
        .setPattern("{criteria}"),
    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)        
        .setActionName("CloseUserSession"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("UnbanUser"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("BanUser"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("TrainerToAdmin"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("AdminToTrainer"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("GetUserResumeForAdmin"),
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName("SwitchAllowEnrollmentWithErrorPayments")
]